<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap-grid.min.css'

export default {
  name: 'App'
}
</script>

<style lang="scss">
#app{
  margin: auto;
  max-width: 1200px;
}

</style>
